// French translations
const fr = {
  cover: {
    title: "Royaume des Échecs",
    subtitle: "Cour du Roi",
    riseOfDukes: "L'Ascension des Ducs",
    enter: "ENTRER",
    aboutUs: "À PROPOS",
    tagline: "Là où naissent les légendes, et chaque coup raconte une histoire",
    selectLanguage: "Choisir la Langue"
  },
  auth: {
    login: "Connexion",
    register: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    username: "Nom d'utilisateur",
    forgotPassword: "Mot de passe oublié?",
    noAccount: "Pas de compte?",
    hasAccount: "Déjà un compte?",
    signUp: "S'inscrire",
    signIn: "Se connecter",
    orContinueWith: "Ou continuer avec",
    guest: "Jouer en invité",
    logout: "Déconnexion"
  },
  lobby: {
    title: "HALL D'ENTRÉE",
    subtitleRise: "L'Ascension des",
    subtitleDukes: "Ducs",
    quickPlay: "PARTIE RAPIDE",
    createRoom: "CRÉER SALLE",
    joinRoom: "REJOINDRE",
    settings: "Paramètres",
    skins: "SKINS",
    friends: "Amis",
    chat: "Discussion",
    spectate: "OBSERVER",
    roomCode: "Code de salle",
    enterRoomCode: "Entrer le code...",
    join: "Rejoindre",
    create: "Créer",
    private: "Privée",
    public: "Publique",
    players: "Joueurs",
    waiting: "En attente d'un adversaire...",
    ready: "Prêt",
    start: "Commencer",
    gameSetup: "CONFIGURATION",
    chooseVariant: "Choisir Variante et Mode",
    multiplayer: "MULTIJOUEUR",
    onlineMatches: "Parties en Ligne",
    profile: "Profil",
    messages: "Messages",
    assistant: "Assistant",
    help: "Aide",
    exit: "Quitter"
  },
  game: {
    white: "Blancs",
    black: "Noirs",
    whiteToMove: "Aux Blancs de jouer",
    blackToMove: "Aux Noirs de jouer",
    check: "Échec!",
    checkmate: "Échec et Mat!",
    stalemate: "Pat!",
    draw: "Nulle",
    resign: "Abandonner",
    resigns: "Abandonne",
    forfeits: "Forfait",
    offerDraw: "Proposer Nulle",
    acceptDraw: "Accepter Nulle",
    declineDraw: "Refuser Nulle",
    newGame: "Nouvelle Partie",
    leave: "Quitter",
    rules: "RÈGLES",
    moveHistory: "Historique",
    noMovesYet: "Aucun coup joué",
    movesWillAppear: "Les coups apparaîtront ici",
    yourTurn: "Votre Tour",
    opponentTurn: "Tour de l'Adversaire",
    gameOver: "Fin de Partie",
    youWin: "VOUS GAGNEZ!",
    youLose: "Vous avez perdu",
    whiteWins: "Les Blancs gagnent!",
    blackWins: "Les Noirs gagnent!",
    drawGame: "Match Nul!",
    playAgain: "Rejouer",
    backToLobby: "Retour au Hall",
    classic: "CLASSIQUE",
    kingsCourt: "COUR DU ROI",
    fightToBeKing: "Combat pour le Trône",
    kingCaptured: "Roi Capturé!",
    winner: "Vainqueur",
    rematch: "Revanche",
    decline: "Refuser",
    waiting: "En attente...",
    acceptRematch: "Accepter Revanche",
    wantsRematch: "demande une revanche!",
    rematchAccepted: "Revanche acceptée! Nouvelle partie...",
    rematchDeclined: "Revanche refusée. Retour au hall...",
    waitingForOpponent: "En attente de l'adversaire...",
    startingNewGame: "Démarrage nouvelle partie...",
    continue: "Continuer"
  },
  settings: {
    title: "Paramètres",
    boardCustomization: "Personnalisation Plateau et Pièces",
    livePreview: "Aperçu en Direct",
    previewDescription: "Voir votre personnalisation",
    boardTheme: "Couleurs du Plateau",
    pieceTheme: "Couleurs des Pièces",
    customColors: "Couleurs Personnalisées",
    presetThemes: "Thèmes Prédéfinis",
    lightSquares: "Cases Claires",
    darkSquares: "Cases Foncées",
    whitePieces: "Pièces Blanches",
    blackPieces: "Pièces Noires",
    coordinateColor: "Couleur Coordonnées",
    coordinateDescription: "Personnaliser les numéros (1-8) et lettres (a-h)",
    chessPieceSkins: "Skins des Pièces",
    chessPieceSkinsDescription: "Remplacer les pièces par des skins 3D premium",
    dukeSkins: "Skins du Duc",
    dukeSkinsDescription: "Choisir les skins du Duc - le thème du plateau s'adapte!",
    whiteSideDuke: "Duc Côté Blanc",
    blackSideDuke: "Duc Côté Noir",
    autoMatchBoard: "Adapter automatiquement les couleurs",
    saveAndClose: "Sauvegarder et Fermer",
    reset: "Réinitialiser",
    close: "Fermer",
    premium: "Premium",
    default: "Défaut",
    classic: "Classique",
    viewMode: "Mode d'Affichage",
    viewModeDescription: "Choisir la vue de l'échiquier",
    topDown: "Vue de Dessus",
    topDownDescription: "Vue plate comme les plateaux traditionnels",
    perspective3D: "Perspective 3D",
    perspective3DDescription: "Pièces 2D avec angle 3D dynamique",
    skinsApplyTo: "Skins pour Roi, Dame, Tour, Fou, Cavalier, Pion",
    dukeHint: "Gauche: Roi Instantané · Droite: Combat pour le Trône"
  },
  store: {
    title: "Boutique de Skins",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    chessPieces: "Pièces d'Échecs",
    dukeSkins: "Skins du Duc",
    allPiecesBundle: "Pack Toutes les Pièces",
    allDukeBundle: "Pack Tous les Ducs",
    bundleDiscount: "Tous les skins premium à -30%!",
    owned: "Possédé",
    equip: "Équiper",
    buy: "Acheter",
    processing: "Traitement...",
    free: "Gratuit",
    rare: "rare",
    epic: "épique",
    legendary: "légendaire",
    common: "commun",
    securePayment: "Achat unique • Utilisation illimitée • Paiement sécurisé"
  },
  chat: {
    title: "Discussion",
    lobbyChat: "Chat du Hall",
    gameChat: "Chat de Partie",
    typeMessage: "Écrire un message...",
    send: "Envoyer",
    spectatorChat: "Chat Spectateurs",
    playerChat: "Chat Joueurs"
  },
  friends: {
    title: "Amis",
    online: "En ligne",
    offline: "Hors ligne",
    addFriend: "Ajouter Ami",
    removeFriend: "Supprimer",
    invite: "Inviter",
    pending: "En attente",
    accept: "Accepter",
    decline: "Refuser",
    friendRequests: "Demandes d'Amis",
    noFriends: "Pas encore d'amis",
    searchPlayers: "Rechercher joueurs..."
  },
  notifications: {
    friendRequest: "vous a envoyé une demande d'ami",
    gameInvite: "vous invite à jouer",
    yourTurn: "C'est votre tour!",
    opponentJoined: "L'adversaire a rejoint",
    opponentLeft: "L'adversaire a quitté",
    drawOffered: "L'adversaire propose la nulle",
    connected: "Connecté au serveur",
    disconnected: "Déconnecté du serveur",
    reconnecting: "Reconnexion..."
  },
  errors: {
    invalidEmail: "Adresse email invalide",
    invalidPassword: "Le mot de passe doit contenir au moins 6 caractères",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    loginFailed: "Échec de connexion. Vérifiez vos identifiants.",
    registerFailed: "Échec d'inscription. Réessayez.",
    connectionError: "Erreur de connexion. Réessayez.",
    connectionErrorInternet: "Erreur de connexion. Vérifiez votre internet.",
    gameNotFound: "Partie non trouvée",
    roomFull: "Salle pleine",
    invalidMove: "Coup invalide",
    pleaseEnterName: "Veuillez entrer votre nom",
    completeBothSecurityQuestions: "Complétez les deux questions de sécurité ou laissez-les vides",
    selectDifferentQuestions: "Veuillez sélectionner des questions différentes",
    unexpectedError: "Une erreur inattendue s'est produite",
    failedToSendResetCode: "Échec de l'envoi du code de réinitialisation",
    invalidOrExpiredCode: "Code invalide ou expiré",
    failedToResetPassword: "Échec de la réinitialisation. Réessayez.",
    pleaseEnterRoomName: "Veuillez entrer un nom de salle",
    pleaseEnterRoomCode: "Veuillez entrer un code de salle",
    roomCodeMustBe6Chars: "Le code doit contenir 6 caractères",
    roomNotFound: "Salle non trouvée. Vérifiez le code.",
    roomRequiresApproval: "Cette salle nécessite une approbation. Demandez depuis votre liste.",
    failedToCreateRoom: "Échec de création de salle",
    failedToJoinRoom: "Échec de connexion à la salle",
    failedToLeaveRoom: "Échec de sortie de salle",
    failedToRemoveRoom: "Échec de suppression de salle",
    failedToLoadGames: "Échec de chargement des parties",
    failedToRequestRejoin: "Échec de la demande de réintégration",
    failedToJoinMatchmaking: "Échec de connexion au matchmaking",
    noOpponentFound: "Aucun adversaire trouvé. Réessayez plus tard.",
    searchFailed: "Échec de la recherche",
    failedToSendRequest: "Échec de l'envoi de la demande",
    failedToAcceptRequest: "Échec de l'acceptation",
    failedToRejectRequest: "Échec du refus",
    failedToCancelRequest: "Échec de l'annulation",
    failedToRemoveFriend: "Échec de la suppression d'ami"
  },
  success: {
    copiedToClipboard: "Copié dans le presse-papiers!",
    rejoinRequestSent: "Demande envoyée à l'hôte!",
    roomRemovedFromList: "Salle retirée de votre liste.",
    leftRoomSuccessfully: "Vous avez quitté la salle",
    requestRejected: "Demande refusée",
    requestCancelled: "Demande annulée",
    friendRemoved: "Ami supprimé",
    tournamentCreated: "Tournoi créé avec succès!",
    tournamentJoined: "Vous avez rejoint le tournoi!",
    tournamentLeft: "Vous avez quitté le tournoi",
    tournamentStarted: "Tournoi démarré!",
    tournamentCancelled: "Tournoi annulé",
    tournamentsCleared: "Tous les tournois supprimés",
    removedFromHistory: "Retiré de l'historique"
  },
  tournament: {
    title: "Tournois",
    createTournament: "Créer un Tournoi",
    joinTournament: "Rejoindre le Tournoi",
    leaveTournament: "Quitter le Tournoi",
    startTournament: "Démarrer le Tournoi",
    cancelTournament: "Annuler le Tournoi",
    clearAll: "Tout Effacer",
    myTournaments: "Mes Tournois",
    availableTournaments: "Tournois Disponibles",
    tournamentHistory: "Historique des Tournois",
    bracket: "Tableau",
    participants: "Participants",
    status: "Statut",
    waiting: "En Attente",
    inProgress: "En Cours",
    completed: "Terminé",
    cancelled: "Annulé",
    format: "Format",
    singleElimination: "Élimination Simple",
    doubleElimination: "Double Élimination",
    swiss: "Suisse",
    round: "Tour",
    match: "Match",
    ready: "Prêt",
    notReady: "Pas Prêt",
    markReady: "Marquer Prêt",
    winner: "Gagnant",
    loser: "Perdant",
    bye: "Exempté",
    pleaseLoginToCreate: "Connectez-vous pour créer un tournoi",
    pleaseLoginToJoin: "Connectez-vous pour rejoindre un tournoi",
    failedToLoadTournaments: "Échec du chargement des tournois",
    failedToCreateTournament: "Échec de création du tournoi",
    failedToJoinTournament: "Échec de connexion au tournoi",
    failedToLeaveTournament: "Échec de sortie du tournoi",
    failedToStartTournament: "Échec du démarrage du tournoi",
    failedToCancelTournament: "Échec de l'annulation du tournoi",
    failedToClearTournaments: "Échec de suppression des tournois",
    failedToRemoveFromHistory: "Échec de retrait de l'historique",
    failedToLoadTournament: "Échec du chargement du tournoi",
    failedToMarkReady: "Échec du marquage prêt"
  },
  ranked: {
    title: "Classé",
    findMatch: "Trouver un Match Classé",
    inQueue: "En File d'Attente...",
    leaveQueue: "Quitter la File",
    yourRank: "Votre Rang",
    elo: "ELO",
    tier: "Niveau",
    wins: "Victoires",
    losses: "Défaites",
    draws: "Nuls",
    season: "Saison",
    leaderboard: "Classement",
    squire: "Écuyer",
    knight: "Chevalier",
    baron: "Baron",
    duke: "Duc",
    king: "Roi",
    pleaseLoginToPlay: "Connectez-vous pour jouer classé",
    failedToJoinQueue: "Échec de connexion à la file"
  },
  misc: {
    loading: "Chargement...",
    cancel: "Annuler",
    confirm: "Confirmer",
    yes: "Oui",
    no: "Non",
    ok: "OK",
    save: "Sauvegarder",
    delete: "Supprimer",
    edit: "Modifier",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    search: "Rechercher",
    filter: "Filtrer",
    sort: "Trier",
    all: "Tout",
    none: "Aucun",
    select: "Sélectionner",
    selected: "Sélectionné"
  },
  
  // About Us Page
  aboutUs: {
    back: "← Retour",
    title: "Bienvenue à Chess Kingdom: King's Court",
    subtitle: "King's Court",
    riseOfDukes: "Rise of the Dukes",
    description: "Entrez dans un royaume où la stratégie classique rencontre l'échelle mythique. King's Court est plus qu'un mode de jeu - c'est un terrain d'essai pour tacticiens, rêveurs et champions. Que vous soyez un grand maître cherchant un nouveau défi ou un nouveau venu attiré par le frisson de la conquête, voici votre arène. ⚔️",
    keyFeatures: "Caractéristiques Principales",
    feature1Title: "Variantes Dynamiques",
    feature1Desc: "Explorez des ensembles de règles et des dispositions de plateau en évolution qui testent votre adaptabilité et votre prévoyance.",
    feature2Title: "Progression Courtoise",
    feature2Desc: "Gagnez des titres, débloquez des emblèmes et montez à travers un système de classement richement stratifié qui récompense la maîtrise et le style.",
    feature3Title: "Jeu Basé sur les Compétences",
    feature3Desc: "Retour d'information transparent, équilibre ajusté par télémétrie et matchmaking équitable garantissent que chaque victoire est méritée.",
    feature4Title: "Chat en Direct et Fils de Lore",
    feature4Desc: "Connectez-vous avec rivaux et alliés, découvrez le lore procédural et façonnez la mythologie de votre royaume.",
    feature5Title: "Conçu pour les Pros",
    feature5Desc: "Réglage de précision, analyse de replay et infrastructure prête pour les tournois font de King's Court une plateforme sérieuse pour le jeu compétitif.",
    closingStatement: "Que vous cherchiez la gloire, la croissance ou la grande stratégie, King's Court vous invite à régner avec sagesse, combattre avec honneur et laisser votre marque sur le royaume.",
    developmentNotice: "Note: Le jeu est encore en développement, et avec votre patience et soutien, le jeu deviendra un foyer loin de chez soi. Amusez-vous, faites-vous des amis et des alliances, car quand j'aurai terminé, vos méthodes stratégiques pour gagner seront mises à l'épreuve... Bienvenue dans votre Royaume...",
    contactTitle: "Plus d'infos ou suggestions Contacter:",
    contactEmail: "CKKC.customerservice@gmail.com"
  },
  
  // Store
  store: {
    title: "Boutique de Skins",
    themedSets: "Ensembles Thématiques",
    pieceSkins: "Skins de Pièces",
    dukeSkins: "Skins de Duc",
    unlockSet: "Débloquer l'Ensemble",
    owned: "Possédé",
    price: "Prix",
    checkout: "Payer",
    addToCart: "Ajouter au Panier",
    cart: "Panier",
    total: "Total",
    continueShopping: "Continuer les Achats",
    proceedToCheckout: "Procéder au Paiement",
    emptyCart: "Votre panier est vide",
    itemAdded: "Article ajouté au panier",
    purchaseSuccess: "Achat réussi!",
    purchaseFailed: "Achat échoué. Veuillez réessayer."
  },
  
  // Rules
  rules: {
    title: "Règles du Jeu",
    classic: "Échecs Classiques",
    classicDesc: "Règles d'échecs standard - mettez le roi adverse en échec et mat pour gagner.",
    instantKing: "Instant King",
    instantKingDesc: "Capturez le roi ennemi directement pour gagner - pas besoin d'échec et mat!",
    fightToBeKing: "Combat pour être Roi",
    fightToBeKingDesc: "Votre pion promu devient le nouveau roi! Protégez-le ou perdez le jeu.",
    timerRules: "Règles du Chrono",
    timerDesc: "Chaque joueur a un temps limité par coup. Si le temps expire, votre tour est passé."
  },
  
  // Assistant
  assistant: {
    title: "Assistant Chess Kingdom",
    searchPlaceholder: "Rechercher des sujets d'aide...",
    randomTip: "Afficher un conseil aléatoire",
    noResults: "Aucun sujet trouvé pour",
    noResultsHint: "Essayez d'autres mots-clés ou parcourez les catégories ci-dessus",
    categories: {
      gettingStarted: "Démarrer",
      dukeMechanics: "Mécaniques du Duc",
      multiplayer: "Multijoueur",
      customization: "Personnalisation",
      boardFeatures: "Plateau",
      skinStore: "Boutique de Skins",
      trialPayments: "Essai et Paiements",
      strategyTips: "Stratégie",
      troubleshooting: "Dépannage"
    },
    gettingStarted: {
      q1: "Comment commencer à jouer?",
      a1: "Cliquez sur 'Solo' pour jouer contre l'IA, ou 'Multijoueur' pour jouer avec d'autres. Vous pouvez jouer en tant qu'invité ou vous inscrire pour un essai gratuit de 48 heures.",
      q2: "Quelles sont les variantes du jeu?",
      a2: "Chess Kingdom offre 7 variantes: Échecs Standard, Roi Instantané, Combat pour être Roi, Choix du Joueur, Pions Sauvages, Chess Kingdom (Deux Ducs), et Mode Handicap.",
      q3: "Comment personnaliser le plateau?",
      a3: "Cliquez sur Paramètres pour accéder aux options. Vous pouvez changer les couleurs du plateau, les skins des pièces, les skins du duc, les thèmes, la couleur des coordonnées, le mode de vue et la taille du plateau.",
      q4: "Comment retourner la vue du plateau?",
      a4: "Cliquez sur le bouton retourner dans l'en-tête du jeu pour voir le plateau du point de vue des noirs.",
      q5: "Comment changer la taille du plateau?",
      a5: "Allez dans Paramètres → Taille du Plateau. Utilisez le curseur ou cliquez sur 'Compact' (85%), 'Par défaut' (100%), ou 'Grand' (115%)."
    },
    dukeMechanics: {
      q1: "Qu'est-ce que la pièce Duc?",
      a1: "Le Duc est une pièce spéciale qui remplace un Fou. Il se déplace en diagonale (1 case) pour les mouvements sans capture, mais peut capturer dans les 8 directions (cases adjacentes uniquement).",
      q2: "Que se passe-t-il quand mon Roi est capturé?",
      a2: "Votre Duc se transforme en nouveau Roi! Les règles de transformation dépendent du mode: Roi Instantané ou Combat pour être Roi.",
      q3: "Comment fonctionne Combat pour être Roi?",
      a3: "Après la capture de votre Roi, votre Duc doit retourner à sa ligne de base (rangée 1 pour les blancs, rangée 8 pour les noirs) pour se transformer en Roi.",
      q4: "Les pièces Duc peuvent-elles être promues?",
      a4: "Uniquement dans la variante Pions Sauvages! Quand un pion atteint la dernière rangée, vous pouvez le promouvoir en Dame, Tour, Fou, Cavalier ou Duc.",
      q5: "Quelle est la différence entre les skins Roi Instantané et Combat pour être Roi?",
      a5: "Les skins du Duc viennent en deux versions: La version 'Roi Instantané' apparaît pendant le jeu normal, tandis que 'Combat pour être Roi' apparaît quand votre Duc lutte pour atteindre la ligne de base."
    },
    multiplayer: {
      q1: "Comment fonctionne la Partie Rapide?",
      a1: "La Partie Rapide vous associe instantanément avec un autre joueur! Sélectionnez votre mode préféré, cliquez sur 'Trouver une Partie', et vous serez associé à quelqu'un qui a choisi le même mode.",
      q2: "Comment créer et gérer des salles privées?",
      a2: "Allez dans l'onglet 'Créer une Salle', entrez un nom, choisissez la variante, configurez les spectateurs et partagez le code à 6 caractères avec vos amis.",
      q3: "Comment rejoindre la salle d'un ami?",
      a3: "Allez dans l'onglet 'Rejoindre une Salle', entrez le code à 6 caractères partagé par votre ami et cliquez sur 'Rejoindre'.",
      q4: "Quels sont les paramètres de spectateurs?",
      a4: "Privée: Pas de spectateurs. Demander à rejoindre: Les spectateurs doivent demander l'approbation. Ouverte: N'importe qui peut regarder librement.",
      q5: "Comment regarder des parties en tant que spectateur?",
      a5: "Allez dans l'onglet 'Spectateur' pour voir toutes les parties publiques. Filtrez par type de jeu pour trouver des variantes spécifiques.",
      q6: "Puis-je chatter pendant les parties?",
      a6: "Oui! Pendant les parties multijoueur, utilisez le chat du jeu. Les messages sont automatiquement traduits si les joueurs parlent différentes langues!",
      q7: "Mon thème se synchronise-t-il avec les adversaires?",
      a7: "Oui! Si vous êtes l'hôte, votre thème de plateau, skins de pièces et skins du duc se synchronisent automatiquement avec tous les joueurs."
    },
    customization: {
      q1: "Quels skins de pièces sont disponibles?",
      a1: "Nous avons plus de 20 sets: Doré 3D, Obsidienne 3D, Vintage, Kawaii, Fable, Gothique, Colossal, Améthyste Violet, Saphir Bleu, Royaume de Pierre et Sable, et plus encore!",
      q2: "Quels skins du duc sont disponibles?",
      a2: "Plus de 50 skins en catégories: Métallique (Or, Argent), Couleur (Violet, Bleu, Émeraude), Blanc (Spartiate, Aigle), Noir (Acier, Couronne), Gemme, Royaume, Premium 3D, et plus!",
      q3: "Comment changer les skins des pièces?",
      a3: "Paramètres → Skins des Pièces. Vous pouvez définir différents skins pour les côtés blanc et noir séparément! Utilisez 'Aperçu des deux côtés' pour voir comment ils apparaîtront ensemble.",
      q4: "Comment changer les skins du duc?",
      a4: "Paramètres → Skins du Duc. Sélectionnez les skins classés par Blanc, Noir ou Neutre. Chaque duc a des variantes Roi Instantané et Combat pour être Roi.",
      q5: "Que sont les Packs de Thèmes?",
      a5: "Les Packs de Thèmes regroupent les skins de pièces, skins du duc et thèmes de plateau! Comprend Royal Gold, Dark Knight, Vintage Classic et les packs Bataille de Royaume!",
      q6: "Comment obtenir un thème aléatoire?",
      a6: "Cliquez sur 'Pack de Thème Aléatoire' pour appliquer un thème complet au hasard, ou 'Bataille de Royaume Aléatoire' pour un affrontement de factions.",
      q7: "Puis-je personnaliser les couleurs des coordonnées?",
      a7: "Oui! Paramètres → Couleur des Coordonnées. Choisissez n'importe quelle couleur pour les numéros de rangée (1-8) et les lettres de colonne (a-h)."
    },
    boardFeatures: {
      q1: "Quels sont les modes de vue?",
      a1: "Deux modes: Perspective 3D (avec profondeur et ombres) et Vue du Dessus (plat, traditionnel). Changez dans Paramètres → Mode de Vue.",
      q2: "Comment fonctionne la taille du plateau?",
      a2: "Paramètres → Taille du Plateau vous permet d'ajuster de 80% (Compact) à 120% (Grand). Par défaut: 100%.",
      q3: "Quels thèmes de plateau sont disponibles?",
      a3: "Plusieurs thèmes de couleurs: Bois Classique, Or Royal, Chevalier Noir, Bleu Océan, Vert Forêt, Gris Pierre, et plus.",
      q4: "Comment fonctionnent les coordonnées?",
      a4: "Les coordonnées affichent les numéros de rangée (1-8) et les lettres de colonne (a-h) sur les bords du plateau. Elles se retournent correctement en utilisant le bouton retourner!",
      q5: "Le plateau fonctionne-t-il sur mobile?",
      a5: "Oui! Le plateau est entièrement responsive. En mode paysage, le plateau s'ajuste automatiquement à la hauteur de l'écran."
    },
    skinStore: {
      q1: "Comment accéder à la Boutique de Skins?",
      a1: "Cliquez sur le bouton Boutique depuis le lobby, ou accédez via Paramètres → bouton 'Visiter la Boutique'. La boutique a trois onglets: Sets Thématiques, Skins de Pièces et Skins du Duc.",
      q2: "Que sont les Sets Thématiques?",
      a2: "Des packages de thèmes complets à prix réduit! Ils incluent des skins de pièces, skins du duc et thèmes de plateau assortis.",
      q3: "Y a-t-il des réductions sur les packs?",
      a3: "Oui! 'Pack Toutes les Pièces' et 'Pack Tous les Ducs' vous donnent tous les skins avec 40% de réduction.",
      q4: "Comment fonctionnent les raretés des skins?",
      a4: "Commun (gris): Gratuit ou basique. Rare (bleu): 1,99-2,49€. Épique (violet): 2,49-3,99€. Légendaire (or): 3,49-4,99€.",
      q5: "Puis-je prévisualiser avant d'acheter?",
      a5: "Oui! Survolez n'importe quelle carte de skin pour voir un aperçu. Les skins de pièces montrent le Roi, la Dame et le Cavalier.",
      q6: "Comment équiper les skins achetés?",
      a6: "Dans la Boutique, les skins possédés affichent le bouton 'Équiper' au lieu du prix. Cliquez sur Équiper pour appliquer immédiatement."
    },
    trialPayments: {
      q1: "Qu'est-ce que l'essai gratuit de 48 heures?",
      a1: "Les nouveaux utilisateurs obtiennent 48 heures d'accès gratuit à TOUTES les variantes. Après l'essai, les Échecs Standard et Roi Instantané restent gratuits.",
      q2: "Combien coûtent les variantes?",
      a2: "Combat pour être Roi et Mode Handicap: 2,99€, Choix du Joueur: 3,99€, Pions Sauvages et Deux Ducs: 4,99€. Ou obtenez le Pack Toutes Variantes pour 8,99€!",
      q3: "Combien coûtent les skins?",
      a3: "Skins individuels: 1,99-4,99€ selon la rareté. Packs: ~40% de réduction. Sets Thématiques: 8,99-12,99€.",
      q4: "Puis-je jouer en tant qu'invité?",
      a4: "Oui! Le mode invité permet de jouer immédiatement sans inscription. Cependant, l'historique des parties ne sera pas sauvegardé.",
      q5: "Comment fonctionnent les paiements?",
      a5: "Tous les paiements sont traités de manière sécurisée via Stripe. Les achats uniques débloquent le contenu pour toujours. Pas d'abonnement requis."
    },
    strategyTips: {
      q1: "Stratégie d'ouverture du Duc?",
      a1: "Positionnez votre Duc pour contrôler les diagonales centrales tôt. Sa capacité unique de capture dans 8 directions le rend excellent pour menacer plusieurs pièces.",
      q2: "Quand choisir Roi Instantané vs Combat pour être Roi?",
      a2: "Choisissez Roi Instantané si votre Duc est bien positionné. Choisissez Combat pour être Roi si votre Duc est déjà proche de la ligne de base.",
      q3: "Stratégie de la variante Deux Ducs?",
      a3: "Protégez soigneusement les deux Ducs - ce sont vos 'vies supplémentaires'! Quand votre Roi est capturé, choisissez le Duc le plus sûr pour la transformation.",
      q4: "Fin de partie Pions Sauvages?",
      a4: "Envisagez de promouvoir des pions en Ducs comme 'assurance Roi' - si votre Roi est capturé plus tard, un Duc promu peut devenir votre nouveau Roi!",
      q5: "Utiliser le retournement du plateau stratégiquement?",
      a5: "Retournez le plateau pour voir les positions du point de vue de votre adversaire! Cela aide à identifier les menaces que vous pourriez manquer."
    },
    troubleshooting: {
      q1: "Le jeu se charge lentement",
      a1: "Essayez le bouton Dépanneur pour exécuter les diagnostics. Vérifiez votre connexion internet. Essayez de rafraîchir la page (Ctrl+F5).",
      q2: "Le multijoueur ne se connecte pas",
      a2: "Utilisez le Dépanneur pour vérifier l'état de la connexion WebSocket. Assurez-vous d'être connecté. Vérifiez les problèmes de pare-feu/VPN.",
      q3: "Les paramètres ne se sauvegardent pas",
      a3: "Les paramètres utilisent localStorage. Vérifiez si votre navigateur le permet. Essayez l'option 'Réinitialiser les Paramètres' du Dépanneur.",
      q4: "Où est l'historique des coups?",
      a4: "La barre latérale de l'historique des coups apparaît sur le côté DROIT pendant les parties actives. Nécessite une largeur de navigateur > 768px.",
      q5: "Le curseur de taille du plateau ne fonctionne pas?",
      a5: "Essayez: 1) Rafraîchir la page. 2) Vider le cache du navigateur. 3) Vérifier si vous êtes en partie. 4) Essayer un autre mode de vue.",
      q6: "Les pièces semblent trop petites/grandes?",
      a6: "Différents skins de pièces ont des tailles optimales différentes. Allez dans Paramètres → Taille du Plateau pour ajuster.",
      q7: "J'ai oublié mon mot de passe?",
      a7: "Allez sur la page Compte → 'Mot de passe oublié?' → Répondez à vos questions de sécurité → Le mot de passe sera envoyé à votre email.",
      q8: "Comment contacter le support?",
      a8: "Utilisez le Dépanneur pour les problèmes techniques. Pour les problèmes de facturation/compte, envoyez un email depuis la page Compte."
    },
    tips: {
      tip1: "Le Duc peut capturer dans 8 directions mais ne se déplace qu'en diagonale quand il ne capture pas!",
      tip2: "En mode Combat pour être Roi, votre Duc doit atteindre la ligne de base pour se transformer.",
      tip3: "Positionnez votre Duc pour contrôler plusieurs cases - son mouvement unique est puissant!",
      tip4: "Dans la variante Deux Ducs, protéger les deux Ducs vous donne plus d'options de remontée.",
      tip5: "Dans Pions Sauvages, promouvoir en Duc vous donne une 'assurance Roi' si capturé.",
      tip6: "Partie Rapide: Sélectionnez le même mode que votre adversaire pour être associé instantanément!",
      tip7: "Les salles créées apparaissent dans 'Mes Salles', les salles rejointes dans 'Salles Rejointes'.",
      tip8: "Définissez votre salle comme 'Ouverte' pour que n'importe qui puisse regarder vos parties épiques!",
      tip9: "Mode Demande: Les joueurs doivent approuver les spectateurs - parfait pour l'enseignement privé.",
      tip10: "Vous pouvez créer max 5 salles. Annulez ou terminez pour en créer plus.",
      tip11: "Cliquez sur Paramètres pour changer les couleurs du plateau et des pièces à tout moment.",
      tip12: "Tous vos coups sont enregistrés dans la barre latérale à droite de l'écran.",
      tip13: "Les messages sont auto-traduits pour les joueurs parlant différentes langues!",
      tip14: "Chaque salle privée obtient un code unique à 6 caractères à partager avec vos amis.",
      tip15: "Packs de Thèmes: Obtenez des pièces, ducs et thèmes de plateau assortis en un clic!",
      tip16: "Essayez Pierre et Sable vs Guerriers de la Forêt pour une guerre de factions épique!",
      tip17: "Laissez le jeu choisir un thème aléatoire pour vous - découvrez de nouveaux favoris!",
      tip18: "Améthyste Violet et Saphir Bleu font briller vos pièces!",
      tip19: "Cliquez sur le bouton retourner pour voir du point de vue des noirs - super pour l'analyse!",
      tip20: "Tournez votre appareil pour une vue plus grande du plateau sur mobile!",
      tip21: "Utilisez le curseur dans Paramètres pour ajuster le plateau de 80% à 120%!",
      tip22: "Les sets Colossal présentent des pièces sculptées épiques en marbre et bronze!",
      tip23: "Quatre sets de pièces emoji Kawaii mignons - Marron, Blanc, Noir et Beige!",
      tip24: "Les sets Gothique Blanc et Noir présentent des designs de fantasy sombre!",
      tip25: "Fable Médiéval: Chevaliers croisés vs guerriers sombres - pièces de bataille épiques!"
    }
  },

  // Account Manager
  account: {
    title: "Gestion du Compte",
    accountInfo: "Informations du Compte",
    usernameEmail: "Utilisateur/Email",
    displayName: "Nom d'Affichage",
    accountType: "Type de Compte",
    userId: "ID Utilisateur",
    guest: "Invité",
    registered: "Enregistré",
    notAvailable: "N/D",
    notificationSettings: "Paramètres de Notifications",
    notificationSound: "Son de Notification",
    notificationSoundDesc: "Jouer un son quand vous recevez des notifications",
    security: "Sécurité",
    passwordManagement: "Gestion du Mot de Passe",
    passwordNote: "Pour des raisons de sécurité, nous n'affichons pas les mots de passe. Si vous devez réinitialiser votre mot de passe, utilisez la fonction 'Mot de passe oublié'.",
    forgotPassword: "Mot de passe oublié?",
    passwordRecovery: "Récupération du Mot de Passe",
    passwordRecoveryHelp: "Répondez à vos questions de sécurité pour recevoir votre mot de passe par email",
    securityQuestion1: "Question de Sécurité 1",
    securityQuestion2: "Question de Sécurité 2",
    selectQuestion: "Sélectionnez une question...",
    yourAnswer: "Votre réponse",
    sendPasswordEmail: "Envoyer le Mot de Passe par Email",
    securityQuestions: {
      q1: "Quel était le nom de votre premier animal de compagnie?",
      q2: "Dans quelle ville êtes-vous né?",
      q3: "Quel est le nom de jeune fille de votre mère?",
      q4: "Quel était le nom de votre école primaire?",
      q5: "Quel est votre livre préféré?",
      q6: "Quel était votre surnom d'enfance?",
      q7: "Quel est le nom de votre professeur préféré?",
      q8: "Dans quelle rue avez-vous grandi?"
    },
    dangerZone: "Zone de Danger",
    deleteAccount: "Supprimer le Compte",
    deleteAccountDesc: "Supprimer définitivement votre compte et toutes les données associées.",
    deleteWarning: "Ceci supprimera définitivement:",
    deleteWarningItems: {
      account: "Votre compte et profil",
      gameHistory: "Tout l'historique des parties",
      friends: "Connexions d'amis",
      purchases: "Variantes achetées",
      settings: "Paramètres et préférences"
    },
    typeDelete: "Tapez DELETE pour confirmer:",
    typeDeletePlaceholder: "Tapez DELETE ici",
    deleteForever: "Supprimer Mon Compte Pour Toujours",
    deleteConfirmMsg: "Cette action ne peut pas être annulée.",
    deleteSuccess: "Compte supprimé avec succès. Vous serez déconnecté.",
    deleteFailed: "Échec de la suppression du compte",
    passwordResetSuccess: "Réinitialisation réussie! Votre mot de passe a été envoyé à votre adresse email. Vérifiez votre boîte de réception (et le dossier spam).",
    securityAnswersIncorrect: "Réponses de sécurité incorrectes. Veuillez réessayer.",
    passwordResetFailed: "Échec de la réinitialisation du mot de passe. Veuillez réessayer.",
    answerBothQuestions: "Veuillez répondre aux deux questions de sécurité"
  }
};

export default fr;
